export const brandPalette = {
    green: {
        300: 'hsl(151, 55%, 75%)',
        400: 'hsl(161, 50%, 50%)',
        '400a': 'hsla(161, 50%, 50%, 0.8)',
        500: 'hsl(172, 100%, 30%)',
        700: 'hsl(172, 100%, 24%)',
        '700a': 'hsla(172, 100%, 24%, 0.8)',
    },
    white: {
        100: 'hsl(72, 26%, 96%)',
    },
    grey: {
        0: 'hsl(255, 7%, 99%)',
        100: 'hsl(255, 7%, 96%)',
        200: 'hsl(255, 7%, 91%)',
        300: 'hsl(255, 7%, 76%)',
        400: 'hsl(255, 7%, 66%)',
        500: 'hsl(255, 7%, 56%)',
        600: 'hsl(255, 7%, 46%)',
        700: 'hsl(255, 7%, 36%)',
        800: 'hsl(255, 7%, 24%)',
        900: 'hsl(255, 7%, 19%)',
    },
    orange: {
        300: 'hsl(32, 91%, 73%)',
        '300a': 'hsla(32, 91%, 73%, 0.8)',
        500: 'hsl(38, 84%, 56%)',
        '500a': 'hsla(38, 84%, 56%, 0.8)',
    },
    red: {
        300: 'hsl(360, 100%, 80%)',
        '300a': 'hsla(360, 100%, 80%, 0.8)',
        400: 'hsl(360, 80%, 70%)',
        500: 'hsl(360, 63%, 61%)',
        '500a': 'hsla(360, 63%, 61%, 0.8)',
    },
    yellow: {
        300: 'hsl(53, 80%, 74%)',
        '300a': 'hsla(53, 80%, 74%, 0.8)',
        400: 'hsl(53, 80%, 62%)',
        500: 'hsl(53, 84%, 50%)',
        '500a': 'hsla(53, 84%, 50%, 0.8)',
    },
    indigo: {
        300: 'hsl(231, 100%, 84%)',
        '300a': 'hsla(231, 100%, 84%, 0.8)',
        500: 'hsl(230, 40%, 55%)',
        '500a': 'hsla(230, 40%, 55%, 0.8)',
    },
    purple: {
        300: 'hsl(271, 100%, 84%)',
        500: 'hsl(271, 40%, 55%)',
    },
    blue: {
        50: 'hsl(202, 82%, 99%)',
        100: 'hsl(202, 82%, 89%)',
        200: 'hsl(202, 82%, 79%)',
        300: 'hsl(202, 82%, 69%)',
        400: 'hsl(202, 82%, 59%)',
        500: 'hsl(202, 82%, 49%)',
        600: 'hsl(202, 82%, 39%)',
        700: 'hsl(202, 82%, 29%)',
        800: 'hsl(202, 82%, 19%)',
        900: 'hsl(202, 82%, 9%)',
    },
    brown: {
        300: 'hsl(28, 44%, 65%)',
        '300a': 'hsla(28, 44%, 65%, 0.8)',
        500: 'hsl(28, 44%, 41%)',
        '500a': 'hsla(28, 44%, 41%, 0.8)',
    },
    cadet: {
        300: 'hsl(202, 65%, 76%)',
        '300a': 'hsla(202, 65%, 76%, 0.8)',
        500: 'hsl(202, 55%, 52%)',
        '500a': 'hsla(202, 55%, 52%, 0.8)',
    },
};
export const gutMicrobiomeTypeNameToColor = {
    Bifidobacterium: brandPalette.green['700a'],
    Bacteroidaceae: brandPalette.orange['500a'],
    Enterobacteriaceae: brandPalette.red['500a'],
    Enterococcus: brandPalette.yellow['500a'],
    Streptococcus: brandPalette.brown['500a'],
    Staphylococcus: brandPalette.cadet['500a'],
    Other: brandPalette.indigo['500a'], // Default for 'Other' type
};
const gutMicrobiomeColorNameMapping = {
    // Type 1: Bifidobacterium (Green)
    Bifidobacterium: gutMicrobiomeTypeNameToColor.Bifidobacterium,
    '1a': gutMicrobiomeTypeNameToColor.Bifidobacterium,
    '1b': gutMicrobiomeTypeNameToColor.Bifidobacterium,
    Actinobacteriota: gutMicrobiomeTypeNameToColor.Bifidobacterium,
    Protective: gutMicrobiomeTypeNameToColor.Bifidobacterium,
    // Type 2: Bacteroidaceae (Orange)
    Bacteroidaceae: gutMicrobiomeTypeNameToColor.Bacteroidaceae,
    Bacteroides: gutMicrobiomeTypeNameToColor.Bacteroidaceae,
    Bacteroidota: gutMicrobiomeTypeNameToColor.Bacteroidaceae,
    '2a': gutMicrobiomeTypeNameToColor.Bacteroidaceae,
    '2b': gutMicrobiomeTypeNameToColor.Bacteroidaceae,
    Variable: gutMicrobiomeTypeNameToColor.Bacteroidaceae,
    // Type 3: Enterobacteriaceae (Red)
    Enterobacteriaceae: gutMicrobiomeTypeNameToColor.Enterobacteriaceae,
    '3a': gutMicrobiomeTypeNameToColor.Enterobacteriaceae,
    '3b': gutMicrobiomeTypeNameToColor.Enterobacteriaceae,
    Proteobacteria: gutMicrobiomeTypeNameToColor.Enterobacteriaceae,
    Disruptive: gutMicrobiomeTypeNameToColor.Enterobacteriaceae,
    // Type 4: Enterococcus (Yellow)
    Enterococcus: gutMicrobiomeTypeNameToColor.Enterococcus,
    '4a': gutMicrobiomeTypeNameToColor.Enterococcus,
    '4b': gutMicrobiomeTypeNameToColor.Enterococcus,
    // Type 5: Streptococcus (Brown)
    Streptococcus: gutMicrobiomeTypeNameToColor.Streptococcus,
    '5a': gutMicrobiomeTypeNameToColor.Streptococcus,
    '5b': gutMicrobiomeTypeNameToColor.Streptococcus,
    // Type 6: Staphylococcus (Cadet)
    Staphylococcus: gutMicrobiomeTypeNameToColor.Staphylococcus,
    // Type 7: Other (Indigo)
    Other: gutMicrobiomeTypeNameToColor.Other,
    Unknown: gutMicrobiomeTypeNameToColor.Other,
    '7a': gutMicrobiomeTypeNameToColor.Other,
    '7b': gutMicrobiomeTypeNameToColor.Other,
    // Kept original as they don't map to the 7 types and are not numeric aliases
    Firmicutes: '#ABB8FF',
    Fusobacteriota: '#DFF7EB',
    Ruminococcaceae: '#f2e588',
    Prevotella: '#9BE2C0',
    Lachnospiraceae: '#CDEAFA',
};
export const getGutMicrobiomeColor = (name) => {
    return (gutMicrobiomeColorNameMapping[name] || gutMicrobiomeTypeNameToColor.Other);
};
//# sourceMappingURL=getGutMicrobiomeColors.js.map